module.exports = __webpack_public_path__ + "static/media/giji4.adf1de96.png";